import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";

import { AppUtil } from "../../../utils/app.util";
import { InsuranceData } from "src/app/models/dmv/insuranceData";
@Component({
	selector: "dmv-pickup-in-person-model",
	templateUrl: "./pickup-in-person-model.component.html",
	styleUrls: ["./pickup-in-person-model.component.css"]
})
export class PickupInPersonModelComponent implements OnInit {
	constructor(
		private formBuilder: FormBuilder,
		public dmvStoreService: DMVStoreService
	) {}
	public name: string;
	public errorMessage: string = "";
	public submitted = false;
	public authorizedPersonForm: FormGroup;
	public isPopupOpen: boolean = true;
	public insuranceData: InsuranceData = {};
	@Output()
	public closeAuthorizedPerson: EventEmitter<any> = new EventEmitter();
	@Output()
	public updateAuthorizedPerson: EventEmitter<any> = new EventEmitter();
	ngOnInit() {
		AppUtil.log("PickupInPersonModelComponent ngOnInit() == >");
		this.name = this.dmvStoreService.registrationsInCart.pickupInPerson
			? this.dmvStoreService.registrationsInCart.pickupInPerson.authorizedPerson
			: null;
		this.authorizedPersonForm = this.formBuilder.group({
			name: [this.name, Validators.required]
		});
	}
	public get f() {
		return this.authorizedPersonForm.controls;
	}
	public submit() {
		this.submitted = true;
		if (this.authorizedPersonForm.invalid) {
			// this.errorMessage =
			// 	"Please certify the FL Insurance Affidvit by checking the checkbox.";
			console.log("insuranceForm.invalid");
			return;
		}
		this.errorMessage = "";
		this.name = this.authorizedPersonForm.controls.name.value;
		AppUtil.log("PickupInPersonModelComponent submit() == >", this);
		this.updateAuthorizedPerson.emit(this);
	}
	public close() {
		AppUtil.log("PickupInPersonModelComponent close() == >");
		this.isPopupOpen = false;
		this.closeAuthorizedPerson.emit();
	}
}
